import {PostCardProps} from 'components/blog/PostCard';
import moment from 'moment-timezone';
import {getImage, ImageUse} from 'utils/types/image';

import {PostData, PostTopic} from './types';

export const parsePosts = (posts: PostData[]): PostCardProps[] => {
	return posts.map((post) => {
		const alt = post?.imgAlts?.find(({data: {use}}) => use === ImageUse.thumbnail);
		if (!post.thumb || !alt) {
			throw new Error(`No thumbnail: '${post.title}'`);
		}

		return {
			...post,

			// Unset optional values on component
			featured: undefined,
			className: undefined,

			// Custom parsing for computed values
			date: moment(post.published).toDate(),
			featuredTopic: post.featured,
			image: {
				alt: alt.data.altText,
				image: getImage(post.thumb),
			},
		};
	});
};

export const parseTopics = (posts: PostData[]): PostTopic[] => {
	const topics = new Set<string>();
	posts.forEach((post) => {
		for (const topic of post.topics) {
			topics.add(topic);
		}
	});

	return Array.from(topics)
		.sort()
		.map((s) => ({
			raw: s,
			pretty: s.replace(/^\d+:\s+/, ''),
		}));
};
